import React from "react";
import VerticalTabs from "./VerticalTabs";

export default function RTPermissions() {
  return (
    <div
      style={{
        padding: "0.5rem",
      }}
    >
      <VerticalTabs />
    </div>
  );
}
